"use client";

import { ReactNode, useState } from "react";
import { Button, Menu } from "@mui/material";

export default function ProfileIconClient({
  image,
  menuItems,
}: {
  image: ReactNode;
  menuItems: ReactNode;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  return (
    <>
      <Button
        onClick={(event) => setAnchorEl(event.currentTarget)}
        className="p-0 rounded-full h-10 w-10 min-w-10"
      >
        {image}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => {
          setAnchorEl(null);
        }}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
      >
        {menuItems}
      </Menu>
    </>
  );
}
